import { useEffect } from "react";

/**
 * Sets the browser tab title to `HEALTHOS · <pageName>` while the
 * component is mounted, and reverts to the default on unmount.
 *
 * Per-page rather than centralised in App.tsx because each route knows
 * its own context (`Today`, `Score`, `Plan`, etc.) and pulling that into
 * the router would either need a registry of route → title lookups or
 * a context tree, both of which leak page concerns into shell code.
 */
export function useDocumentTitle(pageName: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = `Thrive HealthOS · ${pageName}`;
    return () => {
      document.title = previous;
    };
  }, [pageName]);
}
